const Depth = () => {
  return (
    <svg width="9" height="11" viewBox="0 0 9 11" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 0H9H1ZM9 10.75H3C1.48122 10.75 0.25 9.51878 0.25 8H1.75C1.75 8.69036 2.30964 9.25 3 9.25H9V10.75ZM3 10.75C1.48122 10.75 0.25 9.51878 0.25 8V0H1.75V8C1.75 8.69036 2.30964 9.25 3 9.25V10.75ZM9 0V10V0Z"
        fill="#A4A5B1"
      />
    </svg>
  );
};

export default Depth;
